var old = require("./old");
module.exports = {
  getLanguageValue: function (str, isZh) {
    var data = Object.assign({}, old);
    if (isZh) {
      return str;
    }
    if (data[str]) {
      return data[str].charAt(0).toUpperCase() + data[str].slice(1);
    }
    return str;
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/_i18n/language/app.js
// module id = 165
// module chunks = 0